<template>
  <div v-b-tooltip.hover :title=" pax ? (pax.fname + ' ' + pax.lname) : ''">
    <div
      :class="{
        slot: true,
        selectable: isSelectable,
        seat: isSeat,
        notSeat: !isSeat,
        unavailable: isUnavailable,
        occupied: occupied,
        seatSelected: isSelected
      }"
      @click="$emit('select')"
      >
      <div>
        <b-iconstack>
          <b-icon stacked icon="person-plus-fill" v-if="isSeat && !occupied" />
          <b-icon stacked icon="x-circle-fill" v-if="isSeat && occupied" />
          <b-icon stacked icon="blank" v-if="!isSeat" />
        </b-iconstack>
      </div>
      <div>
        <small><strong>{{ label }}</strong></small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    occupied: {
      type: Boolean,
      default: false
    },
    pax: {
      type: Object,
      default: null
    }
  },
  computed: {
    label () {
      return this.data.label
    },
    comment () {
      return this.data.comment
    },
    isSeat () {
      return this.data.type === 'seat'
    },
    isUnavailable () {
      return this.data.status === 'unavailable'
    },
    isSelected () {
      return !!this.pax
    },
    isSelectable () {
      return this.isSeat && this.isAvailable && !this.occupied && !this.isSelected
    }
  }
}
</script>

<style>
.slot {
  background-color: #f0f0f0;
  /* rounded lighgray border */
  border-radius: 5px;
  border: 1px solid #f0f0f0;
  width: 70px;
  height: 50px;
  cursor: pointer;
}

.seat {
  background-color: #55c40a;
  color: #f0f0f0;
}

.occupied, .unavailable {
  background-color: #435d80;
  cursor: not-allowed;
}

.notSeat {
  background-color: #f0f0f0;
}

.selectable:hover {
  background-color: #e6e6e6;
  cursor: pointer;
}

.seatSelected {
  background-color: lightcoral;
  cursor:grab;
}

</style>
